/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Contact_Fiverr_HighlightInputs */

const en_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const ar_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const bn_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const de_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const es_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const fr_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const pt_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinco`)
};

const zh_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const tr_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const ru_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

const pl_heading_contact_fiverr_highlight = /** @type {(inputs: Heading_Contact_Fiverr_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr`)
};

/**
* | output |
* | --- |
* | "Fiverr" |
*
* @param {Heading_Contact_Fiverr_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_contact_fiverr_highlight = /** @type {((inputs?: Heading_Contact_Fiverr_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Contact_Fiverr_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_contact_fiverr_highlight(inputs)
	if (locale === "bn") return bn_heading_contact_fiverr_highlight(inputs)
	if (locale === "de") return de_heading_contact_fiverr_highlight(inputs)
	if (locale === "es") return es_heading_contact_fiverr_highlight(inputs)
	if (locale === "fr") return fr_heading_contact_fiverr_highlight(inputs)
	if (locale === "pt") return pt_heading_contact_fiverr_highlight(inputs)
	if (locale === "zh") return zh_heading_contact_fiverr_highlight(inputs)
	if (locale === "tr") return tr_heading_contact_fiverr_highlight(inputs)
	if (locale === "ru") return ru_heading_contact_fiverr_highlight(inputs)
	if (locale === "pl") return pl_heading_contact_fiverr_highlight(inputs)
	return en_heading_contact_fiverr_highlight(inputs)
});